import './styles.scss';
import logoDlGO from '../../../assets/images/dlocalGo.svg';

const TermsAndCondotions = () => {
  return (
    <div className="terms-and-conditions">
      <div className="doc-content">
        <p className="c69 c56 c93">
          <span className="c52 c86">Terms and Conditions for the use of Dlocal Direct</span>
          <img className="c86-img" src={logoDlGO} alt="" />
        </p>
        <p className="c9">
          <span className="c14"></span>
        </p>
        <p className="c67 c69 c56">
          <span className="c20">We are Dlocal LLP (&ldquo;</span>
          <span className="c2">we</span>
          <span className="c20">&rdquo;, &ldquo;</span>
          <span className="c2">us</span>
          <span className="c20">&rdquo; or &ldquo;</span>
          <span className="c2">Dlocal</span>
          <span className="c20">&rdquo; the </span>
          <span className="c2">&ldquo;Processor&rdquo;</span>
          <span className="c1">
            ), a company registered in England and Wales and with our registered office at 4 King&rsquo;s Bench Walk, Temple,
            London, EC4Y 7DL, United Kingdom.
          </span>
        </p>
        <p className="c9">
          <span className="c1"></span>
        </p>
        <p className="c47">
          <span className="c20">This Agreement and Term &amp; Conditions (together the &ldquo;</span>
          <span className="c2">Agreement</span>
          <span className="c20">&rdquo;) is a contract between </span>
          <span className="c1">you (&ldquo;</span>
          <span className="c21 c2">you</span>
          <span className="c1">&rdquo;, the &ldquo;</span>
          <span className="c21 c2">user</span>
          <span className="c1">&rdquo; or the &ldquo;</span>
          <span className="c21 c2">Merchant</span>
          <span className="c1">
            &rdquo;) and governs your use of Dlocal Direct Services and to offer Payouts (if applicable).
          </span>
        </p>
        <p className="c30">
          <span className="c1"></span>
        </p>
        <p className="c0">
          <span className="c1">
            By using our services, you confirm that you accept these Agreement and our Terms and that you agree to comply
            with them. If you do not agree to these Terms, you must not use our Services. Please note that you agree to be
            bound by these Terms and the other documents expressly referred to in it, from the time that you register to use
            the Services up until the time your Account is terminated.
          </span>
        </p>
        <p className="c25">
          <span className="c1"></span>
        </p>
        <p className="c47">
          <span className="c1">
            This is an important document which you must consider carefully when choosing whether to use the Dlocal Services.
            Please note the following risks of using Dlocal Services:
          </span>
        </p>
        <p className="c30">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_16-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              Payments received in your Account may be reversed at a later time, for example, if a payment is subject to a
              Chargeback, Reversal, Claim or is otherwise invalidated. This means that a payment may be reversed from your
              Account after you have provided the sender the goods or services that were purchased.
            </span>
          </li>
        </ol>
        <p className="c68 c55 c73">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_16-0" start={2}>
          <li className="c31 li-bullet-0">
            <span className="c1">
              We may close, suspend, or limit your access to your Account or the Dlocal Services, and/or limit access to your
              funds if you violate this Agreement, the Dlocal Acceptable Use Policy, or any other agreement you enter into
              with Dlocal.
            </span>
          </li>
        </ol>
        <p className="c73 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_16-0" start={3}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              You are solely responsible for understanding and complying with any and all laws, rules and regulations of your
              specific jurisdiction that may be applicable to you in connection with your use of the Dlocal Direct Services,
              including but not limited to, those related to export or import activity, taxes or foreign currency
              transactions.
            </span>
          </li>
        </ol>
        <p className="c25">
          <span className="c1"></span>
        </p>
        <p className="c69 c56 c94">
          <span className="c1">
            You should print a copy of these Terms or save them to your computer for future reference.
          </span>
        </p>
        <p className="c25">
          <span className="c21 c38"></span>
        </p>
        <p className="c69 c56 c71">
          <span className="c1">
            We amend these Terms from time to time as set out in clause c). Every time you wish to use our Services, please
            check these Terms to ensure you understand the terms which will apply at that time. These Terms were most
            recently updated on February 2022.
          </span>
        </p>
        <p className="c71 c69 c56 c55">
          <span className="c1"></span>
        </p>
        <p className="c71 c69 c56 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0 start" start={2}>
          <li className="c12 li-bullet-0">
            <span className="c14">Definitions</span>
          </li>
        </ol>
        <p className="c25">
          <span className="c14"></span>
        </p>
        <p className="c26">
          <span className="c1">&ldquo;</span>
          <span className="c21 c2">Account</span>
          <span className="c1">&rdquo; means the user&rsquo;s account created after registration to use the Services.</span>
        </p>
        <p className="c25">
          <span className="c21 c38"></span>
        </p>
        <p className="c26">
          <span className="c2">&ldquo;Available Amount&rdquo; </span>
          <span className="c1">has the meaning specified in Clause 7 b (i).</span>
        </p>
        <p className="c25">
          <span className="c21 c38"></span>
        </p>
        <p className="c34">
          <span className="c21 c2">&quot;Business Days&quot; </span>
          <span className="c1">
            means any day other than: (i) a Saturday or Sunday; (ii) a holiday and/or; (iii) a day on which banking
            institutions are Authorized by law in{' '}
          </span>
          <span className="c20">UK</span>
          <span className="c1">&nbsp;by a regulatory order to be closed.</span>
        </p>
        <p className="c25">
          <span className="c1"></span>
        </p>
        <p className="c67 c69 c56">
          <span className="c21 c2">&quot;Chargeback&quot; </span>
          <span className="c1">
            means a circumstance whereby the Customer claims that the products and/or services were not received and
            therefore demands to be refunded the payment made for that product and/or service
          </span>
          <span className="c1">.</span>
        </p>
        <p className="c67 c69 c56 c55">
          <span className="c1"></span>
        </p>
        <p className="c56 c59">
          <span className="c2">&ldquo;Deposit&rdquo; </span>
          <span className="c1">has the meaning specified in Clause 7 a;</span>
        </p>
        <p className="c9">
          <span className="c21 c38"></span>
        </p>
        <p className="c67 c56 c69">
          <span className="c2">&quot;Dlocal Direct Service&quot; </span>
          <span className="c1">
            means the payment processing solution which enables users to pay for the purchase of goods or services: (i)
            directly from accounts held in selected Bank institutions; (ii) through cash payments; (iv) through credit or
            debit Cards; or (v) through other payment methods offered by the Processor;
          </span>
        </p>
        <p className="c76 c69 c56 c55">
          <span className="c11"></span>
        </p>
        <p className="c23">
          <span className="c2">&quot;Fees&quot; </span>
          <span className="c1">means those amounts stated in Clause 9 of this Agreement.</span>
        </p>
        <p className="c25">
          <span className="c21 c38"></span>
        </p>
        <p className="c67 c69 c56">
          <span className="c2">&quot;Information&quot; </span>
          <span className="c1">
            means any Account information that you provide to us, including but not limited to personal information,
            financial information, or other information related to you or your business.
          </span>
        </p>
        <p className="c9">
          <span className="c1"></span>
        </p>
        <p className="c0">
          <span className="c20">&ldquo;</span>
          <span className="c2">Intellectual Property Rights</span>
          <span className="c1">
            &rdquo; means patents, rights to inventions, copyright and related rights, trademarks, trade names and domain
            names, rights in get-up, goodwill and the right to sue for passing off, unfair competition rights, rights in
            designs, rights in computer software, database rights, topography rights, rights to preserve the confidentiality
            of information (including know-how and trade secrets) and any other intellectual property rights, in each case
            whether registered or unregistered and including all applications (or rights to apply) for and be granted,
            renewals or extensions of, and rights to claim priority from, such rights and all similar or equivalent rights or
            forms of protection which subsist or will subsist now or in the future in any part of the world.
          </span>
        </p>
        <p className="c76 c69 c56 c55">
          <span className="c11"></span>
        </p>
        <p className="c0">
          <span className="c2">&quot;Merchant&quot; </span>
          <span className="c20">and </span>
          <span className="c2">&ldquo;Seller&rdquo; </span>
          <span className="c1">
            are used interchangeably and mean a User who is selling goods and/or services and using Dlocal Direct Services to
            receive payments.
          </span>
        </p>
        <p className="c9">
          <span className="c1"></span>
        </p>
        <p className="c0">
          <span className="c2">&ldquo;Payment Processing Services&rdquo; </span>
          <span className="c20">
            means the payment processing services provided by the Processor through Dlocal Direct pursuant to these Terms
            &amp; Conditions; and the processing of Payouts.
          </span>
        </p>
        <p className="c0 c55">
          <span className="c21 c2"></span>
        </p>
        <p className="c0">
          <span className="c2">&ldquo;Payouts&rdquo; </span>
          <span className="c20">
            means the amount transferred by the Processor to a Customer&rsquo;s bank account on the written instruction of
            the PSP
          </span>
        </p>
        <p className="c0 c55">
          <span className="c21 c2"></span>
        </p>
        <p className="c0">
          <span className="c2">&quot;Policy&quot; </span>
          <span className="c20">or </span>
          <span className="c2">&quot;Policies&quot; </span>
          <span className="c1">
            means any Policy or other agreement between you and Dlocal that you entered in connection with your use of the
            Dlocal Direct Services.
          </span>
        </p>
        <p className="c9">
          <span className="c1"></span>
        </p>
        <p className="c0">
          <span className="c2">&quot;Restricted Activities&quot; </span>
          <span className="c1">means those activities described in Section 6 of this Agreement.</span>
        </p>
        <p className="c9">
          <span className="c1"></span>
        </p>
        <hr style={{ pageBreakBefore: 'always', display: 'none' }} />
        <p className="c9">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={3}>
          <li className="c12 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">Payment Services and Eligibility</span>
          </li>
        </ol>
        <p className="c70 c69 c56 c55">
          <span className="c21 c42"></span>
        </p>
        <ol className="c8 lst-kix_list_15-1 start" start={1}>
          <li className="c16 li-bullet-0">
            <span className="c61 c20">Payment Services</span>
          </li>
        </ol>
        <p className="c46">
          <span className="c21 c50"></span>
        </p>
        <p className="c29">
          <span className="c1">
            The Merchant appoints and retains the Processor as its [exclusive] provider of Payment Processing Services in the
            Territory with respect to its Customers.
          </span>
        </p>
        <p className="c29 c55">
          <span className="c1"></span>
        </p>
        <p className="c29">
          <span className="c1">
            The Merchant agrees to accept payment by Dlocal Direct for its online sales and to offer Payouts to its
            Customers.
          </span>
        </p>
        <p className="c29 c55">
          <span className="c1"></span>
        </p>
        <p className="c0">
          <span className="c1">
            The Processor shall assume the obligation to meet the financial obligations arising from the proper use of the
            payment processing methods in accordance with the terms of this Agreement.
          </span>
        </p>
        <p className="c25">
          <span className="c1"></span>
        </p>
        <p className="c47">
          <span className="c1">
            By using Dlocal Direct, you will be able to accept online payments for the products and/or services offered in
            your website from end users or offer Payouts.
          </span>
        </p>
        <p className="c30">
          <span className="c1"></span>
        </p>
        <p className="c67 c69 c56">
          <span className="c1">
            Dlocal Direct Service is payment processing solution which enables users to pay for the purchase of goods or
            services: (i) directly from accounts held in selected Bank institutions; (ii) through cash payments; (iv) through
            credit or debit Cards; (v) through other payment methods offered by the Processor and or offer Payouts;
          </span>
        </p>
        <p className="c67 c69 c56 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-1" start={2}>
          <li className="c59 c44 c56">
            <span className="c61 c20">Eligibility</span>
          </li>
        </ol>
        <p className="c46">
          <span className="c21 c50"></span>
        </p>
        <p className="c29">
          <span className="c1">
            You must be at least 18 years old to register on our Website and to use our Services. We will not provide the
            Services to you if you do not satisfy this age requirement. If you are under 18 years old, please do not attempt
            to use our Services.
          </span>
        </p>
        <p className="c70 c69 c56 c55">
          <span className="c11"></span>
        </p>
        <p className="c0">
          <span className="c1">
            By using our Services, you warrant that you have the right, authority and capacity to enter into and be bound by
            these Terms.
          </span>
        </p>
        <p className="c9">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-1" start={3}>
          <li className="c23 c44">
            <span className="c61 c20">Merchant&rsquo;s KYC Information</span>
          </li>
        </ol>
        <p className="c46">
          <span className="c21 c50"></span>
        </p>
        <ol className="c8 lst-kix_list_15-2 start" start={1}>
          <li className="c65 li-bullet-0">
            <span className="c21 c2">Your contact information. </span>
            <span className="c1">
              It is your responsibility to keep your primary email address up to date so that Dlocal can communicate with you
              electronically. You understand and agree that if Dlocal sends you an electronic communication but you do not
              receive it because your primary email address on file is incorrect, out of date, blocked by your service
              provider, or you are otherwise unable to receive electronic communications, Dlocal will be deemed to have
              provided the communication to you effectively. Please note that if you use a spam filter that blocks or
              re-routes emails from senders not listed in your email address book, you must add Dlocal to your email address
              book so that you will be able to view the communications we send to you.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-2" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c21 c2">Identity Verification. </span>
            <span className="c1">
              You authorize Dlocal, directly or through third parties, to make any inquiries we consider necessary to
              validate your identity. This may include asking you for further information or documentation, requiring you to
              provide a taxpayer or national identification number, requiring you to take steps to confirm ownership of your
              email address or financial instruments, ordering a credit report or verifying your Information against third
              party databases or through other sources.
            </span>
          </li>
        </ol>
        <p className="c66 c55">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_15-2" start={3}>
          <li className="c31 li-bullet-0">
            <span className="c21 c2">Supporting documentation. </span>
            <span className="c1">
              You are required to provide Dlocal with all documentation that may be requested from you time to time in order
              to comply with international standards in terms of Anti-Money Laundry.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-2" start={4}>
          <li className="c17 li-bullet-0">
            <span className="c1">User acknowledge that the </span>
            <span className="c21 c2">
              KYC documentation requested by Dlocal is mandatory in order to use Dlocal Direct Services
            </span>
            <span className="c1">
              . Until the KYC is complete, the User will have a limited capability of processing. You will be unable to
              receive your funds in your account until the KYC is completed.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-2" start={5}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              If the KYC is not successfully completed within 30 days from the opening of the account, the User will be
              unable to continue processing and the account shall be inactivated. Only once all the requested documentation
              has been provided, the User will be capable to request the transfer of the Funds and the close of the account
              or continue accepting payments through the account.
            </span>
          </li>
        </ol>
        <ol className="c8 lst-kix_list_15-0" start={4}>
          <li className="c35 li-bullet-0">
            <span className="c14">Registration with Dlocal</span>
          </li>
        </ol>
        <p className="c9">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_11-0 start" start={1}>
          <li className="c16 li-bullet-0">
            <span className="c1">In order to use Dlocal Direct Services you must register and create an Account.</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_11-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              We may request, at any time (via email, telephone or any other means), any information or documentation that
              can prove your identity, address and/or{' '}
            </span>
            <span className="c21 c62">
              authenticity of the transactions. You agree to provide us with true, precise and complete information.
            </span>
          </li>
        </ol>
        <p className="c37">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_11-0" start={3}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              Upon completing the registration process you will create an Account and receive a password, a username and an
              account number. You must not create more than one Account for your own use of the Website or the Services.
            </span>
          </li>
        </ol>
        <p className="c36">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_11-0" start={4}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              Your Account is personal and shall not be transferred to any individual. In the event that another individual
              accesses the Account due to you having provided any of your account details, you shall be liable for this
              individual&#39;s access. You shall compensate us for all and any losses, damages, costs and expenses we may
              suffer as a result of any failure by you to keep your account details confidential.
            </span>
          </li>
        </ol>
        <p className="c73 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_11-0" start={5}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              You are responsible for: (i) maintaining the confidentiality of the password and username; (ii) not permitting
              others to use your Account; (iii) not using the Accounts of other Users; (iv) refraining from selling, trading,
              or otherwise transferring your Account to another party; (v) immediately notifying us via email at
            </span>
            <span className="c52 c20 c64">&nbsp;</span>
            <span className="c20 c88">
              <a className="c80" href="mailto:merchantsupport@dlocal.com">
                merchantsupport@dlocal.com
              </a>
            </span>
            <span className="c20">&nbsp;</span>
            <span className="c1">
              if you have any suspicion of unauthorized use of your password or Account or any other breach of security,
              including unauthorized use of your debit or credit card.
            </span>
          </li>
        </ol>
        <p className="c66 c55">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_11-0" start={6}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              You must not provide false account details, which include but are not limited to your name, email address, age
              or location. In the event that we have reasons to believe that you have provided us with false account details,
              we reserve the right to terminate the provision of our Services to you and restrict your access, suspend or
              cancel your Account without prior notice. You agree to hold us harmless against any falsehood or inaccuracy
              contained in the information you provide us.
            </span>
          </li>
        </ol>
        <p className="c66 c55">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_11-0" start={7}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              You warrant that the email address with which you register your Account is an active, valid email address
              controlled by you.
            </span>
          </li>
        </ol>
        <p className="c54">
          <span className="c1"></span>
        </p>
        <p className="c9">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={5}>
          <li className="c12 li-bullet-0">
            <span className="c14">Use of our Services</span>
          </li>
        </ol>
        <p className="c36">
          <span className="c21 c42"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              You are responsible for providing and paying for any means and equipment necessary to enable your access to the
              Services.
            </span>
          </li>
        </ol>
        <p className="c45 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              You agree not to disguise, or interfere in any way with, the IP address of the device you are using to access
              the Services or otherwise take steps to prevent us from correctly identifying the actual IP Address of the
              device you are using whilst accessing the Services.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={3}>
          <li className="c57 li-bullet-0">
            <span className="c1">
              When using our Services, you warrant that you are in compliance with all relevant and applicable laws and
              regulations of whatever country you are physically located and with all Dlocal&rsquo;s policies.
            </span>
          </li>
          <li className="c17 li-bullet-0">
            <span className="c1">
              You shall only use the Services for lawful purposes. You shall not use the Services to receive or transmit
              material that is obscene, harassing, and defamatory, in breach of confidentiality or violation of any
              Intellectual Property Rights.
            </span>
          </li>
        </ol>
        <p className="c45 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={5}>
          <li className="c74 li-bullet-0">
            <span className="c1">
              Without prejudice to the right of initiating legal proceedings or reporting the fact to the relevant
              authorities, in the event that we have reasons to believe that you are making any illegal and/or unauthorised
              use of the Services, we reserve the right to restrict your access, suspend or cancel your Account without prior
              notice. Illegal and/or unauthorised use of the Services includes but is not limited to:
            </span>
          </li>
        </ol>
        <p className="c27">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_12-1 start" start={1}>
          <li className="c39 li-bullet-0">
            <span className="c1">using the Services without satisfying the age requirement of at least 18 years old;</span>
          </li>
        </ol>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c51">
          <span className="c1">
            (i) submitting false, inappropriate or inaccurate account details or personal data to us;
          </span>
        </p>
        <p className="c55 c60">
          <span className="c1"></span>
        </p>
        <p className="c32">
          <span className="c1">(i) registering and/or using more than one Account;</span>
        </p>
        <p className="c10">
          <span className="c21 c38"></span>
        </p>
        <p className="c32">
          <span className="c1">(i) engaging in any illegal and/or fraudulent activity;</span>
        </p>
        <p className="c10">
          <span className="c21 c38"></span>
        </p>
        <p className="c67 c75">
          <span className="c1">
            (i) acting in a manner that is detrimental to the conduct of our business or which may result in legal liability
            for you, us or a third party; and
          </span>
        </p>
        <p className="c27">
          <span className="c11"></span>
        </p>
        <p className="c19">
          <span className="c1">(i) providing, creating or disseminating computer viruses.</span>
        </p>
        <p className="c13">
          <span className="c21 c38"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) Imposing surcharge or any other fee for accepting Dlocal Direct as a payment method without our prior written
            consent. You may charge a handling fee in connection with the sale of goods or services, as long as the handling
            fee is not higher than the handling fee you charge for non-Dlocal transactions.
          </span>
        </p>
        <p className="c4">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={6}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              Dlocal will operate the Website with the reasonable skill and care of an online service provider based on the
              relevant industry standard.
            </span>
          </li>
        </ol>
        <p className="c45 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={7}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              Dlocal will use its reasonable endeavors to maintain the operation of the Website and the Services. Whenever it
              is necessary to temporarily suspend the Services for operational or other reasons, Dlocal will use its
              reasonable endeavors to restore the Website and re-establish the provision of the Services.
            </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={8}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              The user acknowledges and agrees that any payment processed via the Services may be subject to limits and
              conditions imposed by the applicable legislation and any regulation authority, and that Dlocal reserves the
              right to restrict the maximum amount of any transaction processed by Dlocal accordingly.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={9}>
          <li className="c31 li-bullet-0">
            <span className="c1">
              Dlocal may subcontract or delegate in any manner any or all of its obligations under this Agreement to any
              third party so as to enable or facilitate the provision of the Services to the user.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={10}>
          <li className="c16 li-bullet-0">
            <span className="c1">The user accepts and authorizes the exchanging rates used by Dlocal.</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={11}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              Dlocal reserves the right to refuse the process transactions through the Services where such transactions are
              not complaint with the applicable legislation, any regulation authority codes of practice or Dlocal&rsquo;s
              policies or operations standards.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_12-0" start={12}>
          <li className="c31 li-bullet-0">
            <span className="c1">
              The user acknowledges and agrees that any transfer of funds made via the Services have the sole purpose of
              allowing users to make payments in good faith in your Websites, and that none of these payments shall be
              considered as a credit granted by Dlocal to the user.
            </span>
          </li>
        </ol>
        <ol className="c8 lst-kix_list_15-0" start={6}>
          <li className="c12 li-bullet-0">
            <span className="c14">Restricted Activities.</span>
          </li>
        </ol>
        <p className="c9">
          <span className="c14"></span>
        </p>
        <p className="c26">
          <span className="c1">In connection with your use of Dlocal Direct Services, you will not:</span>
        </p>
        <p className="c3">
          <span className="c21 c38"></span>
        </p>
        <p className="c15">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">Breach this Agreement, or any other Policy that you have agreed to with Dlocal;</span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c45 c63">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">Violate any law, statute, ordinance, or regulation;</span>
        </p>
        <p className="c70 c63 c55">
          <span className="c18"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) Infringe Dlocal&#39;s or any third party&#39;s copyright, patent, trademark, trade secret or other
            intellectual property rights, or rights of publicity or privacy;
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c45 c63">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">Sell counterfeit goods;</span>
        </p>
        <p className="c3">
          <span className="c21 c38"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) Act in a manner that is defamatory, trade libelous, threatening or harassing to our employees, agents or
            other Users;
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c45 c63">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">Provide false, inaccurate or misleading Information;</span>
        </p>
        <p className="c3">
          <span className="c21 c38"></span>
        </p>
        <p className="c45 c63">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">Engage in potentially fraudulent or suspicious activity and/or transactions;</span>
        </p>
        <p className="c49">
          <span className="c18"></span>
        </p>
        <p className="c15">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            Refuse to cooperate in an investigation or provide confirmation of your identity or any Information you provide
            to us;
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            Conduct your business or use the Dlocal Direct Services in a manner that results in or may result in complaints,
            Disputes, Claims, Reversals, Chargebacks, fees, fines, penalties and other liability to other Users, third
            parties or you;
          </span>
        </p>
        <p className="c3">
          <span className="c1"></span>
        </p>
        <p className="c63 c67">
          <span className="c1">
            (i) Use your Account or Dlocal Direct Services in a manner that Visa, MasterCard, American Express, Discover or
            any other electronic funds transfer network reasonably believes to be an abuse of the card system or a violation
            of card association or network rules;
          </span>
        </p>
        <p className="c49">
          <span className="c11"></span>
        </p>
        <p className="c67 c63">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            Facilitate any viruses, trojan horses, worms or other computer programming routines that may damage,
            detrimentally interfere with, surreptitiously intercept or expropriate any system, data or Information;
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c43">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            Use an anonymizing proxy; use any robot, spider, other automatic device, or manual process to monitor or copy our
            website without our prior written permission;
          </span>
        </p>
        <p className="c3">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) Use any device, software or routine to bypass our robot exclusion headers, or interfere or attempt to
            interfere with our website;
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            Take any action that may cause us to lose any of the services from our Internet service providers, payment
            processors, or other suppliers;
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c43">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            seek to copy, data-mine, cache, reverse engineer, decompile, disassemble or otherwise extract data from Dlocal
            Direct except as otherwise agreed in this Agreement;
          </span>
        </p>
        <p className="c63 c79">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            obtain or claim any ownership in any software (or in any derivation or improvement) connected to Dlocal Direct or
            the Payment Processing Services;
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) sub-license the use of Dlocal Direct to any person (other than its Customers); and/or
          </span>
        </p>
        <p className="c49">
          <span className="c11"></span>
        </p>
        <p className="c15">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            create, write or develop any derivative software or any other software based on Dlocal Direct or the Payment
            Processing Services utilising the proprietary and Confidential Information of the Processor or a third-party
            licensor of the Processor.
          </span>
        </p>
        <p className="c3">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) betting, including lottery tickets, casino gaming chips, off-track betting, memberships on gambling-related
            internet sites and wagers at races that service Territories residents or persons
          </span>
        </p>
        <p className="c49">
          <span className="c11"></span>
        </p>
        <p className="c45 c63">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">foreign exchange trading;</span>
        </p>
        <p className="c3">
          <span className="c21 c38"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) bill payment services (meaning a service that allows debtors to pay their bills to utilities or other
            creditors);
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) items that encourage, promote, facilitate or instruct others to engage in illegal activity to include,
            without limitation, drug trafficking, sex and human trafficking, arms trafficking, or laundering money;
          </span>
        </p>
        <p className="c3">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">(i)</span>
          <span className="c20">&nbsp;</span>
          <span className="c1">
            infringing or encouraging infringement of any intellectual property or any other proprietary right under the
            Applicable Legislation including, but not limited to: offering, providing, selling, furnishing making, having
            made any designer handbags, clothing and accessories, and consumer electronics;
          </span>
        </p>
        <p className="c63 c55 c70">
          <span className="c11"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) promoting hate, violence, racial intolerance, or the financial exploitation of a crime in any manner whether
            directly or indirectly;
          </span>
        </p>
        <p className="c41">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">(i) promoting, supporting or glorifying acts of violence or harm towards self or others</span>
        </p>
        <p className="c49">
          <span className="c11"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) Where payment is made by Dlocal Direct, the Merchant shall not permit any change in the delivery address
            after the Authorization Request has been sent to the Processor.
          </span>
        </p>
        <p className="c3">
          <span className="c1"></span>
        </p>
        <p className="c15">
          <span className="c1">
            (i) To the maximum extent permitted by law, in no event shall the Processor be liable for any payments in excess
            of the Daily Transaction Limit.
            <br />
            <br />
          </span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={7}>
          <li className="c12 li-bullet-0">
            <span className="c14">Payments to the User</span>
          </li>
        </ol>
        <p className="c25">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_14-0 start" start={1}>
          <li className="c31 li-bullet-0">
            <span className="c1">
              A Merchant Deposits shall be withheld from the amounts processed by the User in order to cover Chargebacks and
              refunds (the &ldquo;
            </span>
            <span className="c21 c2">Deposit</span>
            <span className="c1">&rdquo;). The Deposit will be equal to 5% of the amounts processe</span>
            <span className="c52 c20">
              d by Dlocal. Notwithstanding the above, the 5% is subject to change according to{' '}
            </span>
            <span className="c20">Dlocal&rsquo;s</span>
            <span className="c52 c20">&nbsp;assessment of the Merchant. </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_14-0" start={2}>
          <li className="c16 li-bullet-0">
            <span className="c1">Payments to the User shall be made in accordance with the following terms:</span>
          </li>
        </ol>
        <p className="c23 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_14-1 start" start={1}>
          <li className="c79 c82 li-bullet-0" id="h.gjdgxs">
            <span className="c1">
              the amounts processed by the user less fees and any Refunds, Chargebacks and Deposits where applicable and any
              other amounts deductible (the &ldquo;
            </span>
            <span className="c21 c2">Available Amount</span>
            <span className="c1">
              &rdquo;), will be available for payment to the User,within forteen (14) days of the transact
            </span>
            <span className="c52 c20">ion unless </span>
            <span className="c20">Dlocal</span>
            <span className="c52 c20">&rsquo;s assessment of the Mer</span>
            <span className="c20">chant</span>
            <span className="c52 c20">&nbsp;requires a change to shorten or expand such date, fro</span>
            <span className="c1">m when the transaction was made</span>
            <span className="c20">.</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_14-0" start={3}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              In the event any funds due to the User are seized or made unavailable by an action of a law enforcement body,
              regulator or other third party, Dlocal shall use reasonable efforts, at User&rsquo;s expense, to assist the
              User in securing release of such funds as soon as possible.
            </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_14-0" start={4}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              The User shall as soon as practicable, verify the correctness and completeness of the payments and statements
              of account by the Processor. Complaints and objections about these payments may only be made in writing within
              a strict time limit of 8 (eight) weeks after receipt of the payment by the Merchant.
            </span>
          </li>
        </ol>
        <p className="c70 c69 c56 c55">
          <span className="c58">
            <br />
          </span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={8}>
          <li className="c12 li-bullet-0">
            <span className="c14">Payment of Payout</span>
          </li>
        </ol>
        <p className="c9">
          <span className="c21 c2"></span>
        </p>
        <ol className="c8 lst-kix_list_17-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              In the event that a Customer requests a Payout, the Merchant shall request the Processor to issue the Payout
              (in the manner specified by the Processor). The Processor will show to the Customer (and where applicable to
              the Merchant) the Payout amount converted into the applicable local currency (only as backup information). The
              Payout Fee will always be debited in USD. The Processor will send the Payout to the Customer (in the applicable
              local currency) within three (3) Business Days from the Merchant&rsquo;s request.
            </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_17-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              The Processor will send the Payout to the Customer (in the applicable local currency) within three (3) Business
              Days from the Merchant&rsquo;s request, unless the instruction is received after the cut-off time for such
              Payout in which case Processor will process it on the Business Day immediately following the instruction date.{' '}
              <br />
            </span>
          </li>
        </ol>
        <p className="c9">
          <span className="c21 c2"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={9}>
          <li className="c12 li-bullet-0">
            <span className="c14">Dlocal Direct fees and taxes</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_6-0 start" start={1}>
          <li className="c16 li-bullet-0">
            <span className="c1">The Service Fees will be attached hereto as Annex 1.</span>
          </li>
        </ol>
        <p className="c71 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_6-0" start={2}>
          <li className="c31 li-bullet-0">
            <span className="c52 c20">
              In the event the Merchant decides to activate a new means of payment, the Merchant shall accept new Terms and
              Conditions referred to that means of payment specifically.
              <br />
            </span>
          </li>
        </ol>
        <p className="c9">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={10}>
          <li className="c16 li-bullet-0">
            <span className="c28">&nbsp; </span>
            <span className="c14">Intellectual property rights</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_8-0 start" start={1}>
          <li className="c31 li-bullet-0">
            <span className="c1">
              The Intellectual Property Rights on Intellectual Property related to the provision of Services and the Website,
              its functionality and appearance, are either owned by or licensed to Dlocal.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_8-0" start={2}>
          <li className="c16 li-bullet-0">
            <span className="c1">You are expressly prohibited from:</span>
          </li>
        </ol>
        <p className="c13">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_8-1 start" start={1}>
          <li className="c39 li-bullet-0">
            <span className="c1">
              reproducing, copying, sharing, editing, transmitting, uploading, modifying, altering, incorporating into any
              other materials, removing, commercializing or using any Intellectual Property related to the provision of
              Services and the Website, its functionality and appearance;
            </span>
          </li>
        </ol>
        <p className="c13">
          <span className="c1"></span>
        </p>
        <p className="c33">
          <span className="c1">
            (i) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Doing anything which may be seen to take unfair advantage of
            the reputation and goodwill of the Website the Services and/or Dlocal&rsquo;s business in general; and
          </span>
        </p>
        <p className="c13">
          <span className="c1"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Doing anything that could be considered an infringement of
            the Intellectual Property Rights owned and/or licensed to Dlocal without first obtaining the written permission
            of the owner of the Intellectual Property.
          </span>
        </p>
        <p className="c25">
          <span className="c1"></span>
        </p>
        <p className="c25">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={11}>
          <li className="c12 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">How we use your personal information</span>
          </li>
        </ol>
        <p className="c25">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0 start" start={1}>
          <li className="c31 li-bullet-0">
            <span className="c1">
              For the purpose of the Data Protection Act 1998 (the &ldquo;Act&rdquo;), we process personal data as a data
              controller and our registered address is 4 King&rsquo;s Bench Walk, Temple, London, EC4Y 7DL, United Kingdom.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              This clause sets out the basis on which any personal data we collect from you, or that you provide to us, will
              be processed by us. Please read the following carefully to understand our views and practices regarding your
              personal data and how we will treat it.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0" start={3}>
          <li className="c40 li-bullet-0">
            <span className="c1">
              By creating an Account, you are accepting and consenting to the processing of your personal data as set out in
              this clause.
            </span>
          </li>
        </ol>
        <p className="c68 c55 c96">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0" start={4}>
          <li className="c16 li-bullet-0">
            <span className="c1">
              For the purposes of this clause, your personal data (&ldquo;User&rsquo;s Information&rdquo;) may be:
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_1-1 start" start={1}>
          <li className="c39 li-bullet-0">
            <span className="c61 c20">information you give to us:</span>
            <span className="c1">
              &nbsp;this includes, without limitation, your name, address, email address and phone number, financial and
              credit card information, personal description, proof of your identity or address, authorization to use third
              party funds to pay for a transaction through Dlocal Direct, and any other information you submit when
              registering to use our Website or the Services, subscribe to our mailing list, leave us your feedback or report
              a problem with our Website or Services;
            </span>
          </li>
        </ol>
        <p className="c48">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_17-1 start" start={1}>
          <li className="c39 li-bullet-0">
            <span className="c61 c20">Information we collect about you</span>
            <span className="c1">
              : this includes, without limitation, any information we collect about you related to your usage of the Website
              and the Services, including information on the payments made by you through Dlocal Direct, and the nature of
              the services and products purchased; and
            </span>
          </li>
        </ol>
        <p className="c24 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_17-1" start={2}>
          <li className="c39 li-bullet-0">
            <span className="c20 c61">Information we receive from other sources</span>
            <span className="c1">
              : this this includes, without limitation, information we receive about you if you use any of the other websites
              we operate or the other services we provide, or information we receive from third parties (including, for
              example, business partners, sub- contractors, advertising networks, analytics providers, search information
              providers, credit agencies or other agencies)
            </span>
            <span className="c20">.</span>
          </li>
        </ol>
        <ol className="c8 lst-kix_list_1-0" start={5}>
          <li className="c16 li-bullet-0">
            <span className="c1">We may use User&rsquo;s Information in the following ways:</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_1-1" start={2}>
          <li className="c39 li-bullet-0">
            <span className="c1">
              to carry out our obligations arising from any contracts entered into between you and us and to provide you with
              the information, products and services that you request from us;
            </span>
          </li>
        </ol>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) to provide you with information about other goods and services we offer that are similar to those that you
            have already purchased or enquired about;
          </span>
        </p>
        <p className="c76 c75 c55">
          <span className="c11"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) to contact you for your views on our services and to notify you occasionally about important changes or
            developments to our Website or to our Services;
          </span>
        </p>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) to manage our Website and Services, for internal operations, including troubleshooting, data analysis,
            testing, research, statistical and survey purposes;
          </span>
        </p>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c67 c75">
          <span className="c1">(i) to improve our Website, Services and any services and products provided by us;</span>
        </p>
        <p className="c75 c55 c76">
          <span className="c11"></span>
        </p>
        <p className="c19">
          <span className="c1">(i) as part of our efforts to keep our Website and the Services safe and secure;</span>
        </p>
        <p className="c13">
          <span className="c21 c38"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) to measure or understand the effectiveness of advertising we serve to you and others, and to deliver relevant
            advertising to you;
          </span>
        </p>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) to make suggestions and recommendations to you and other users about goods or services that may interest you
            or them;
          </span>
        </p>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c19">
          <span className="c1">(i) to maintain and develop our commercial relationship with you; and</span>
        </p>
        <p className="c13">
          <span className="c21 c38"></span>
        </p>
        <p className="c33">
          <span className="c1">
            (i) to evaluate any financial risks, verify any risks of money laundering, prevent fraud and make any reports
            that we are required to make by the applicable law.
          </span>
        </p>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0" start={6}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              We may combine information we receive from other sources with information you give to us and information we
              collect about you. We may use this combined information for the purposes set out above.
            </span>
          </li>
        </ol>
        <p className="c45 c55 c68">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0" start={7}>
          <li className="c57 li-bullet-0">
            <span className="c1">
              We do not sell, rent, or otherwise provide User&rsquo;s Information to third parties, except where (a) we
              obtain your consent; (b) it is necessary to provide you with our Services; (c) we are required or authorised by
              law; or (d) as described in clause 9.9.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0" start={8}>
          <li className="c16 li-bullet-0">
            <span className="c1">We may share User&rsquo;s Information with:</span>
          </li>
        </ol>
        <ol className="c8 lst-kix_list_1-1 start" start={1}>
          <li className="c79 c82 li-bullet-0">
            <span className="c1">
              any of our employees or any member of our group or their employees, where &ldquo;member of our group&rdquo;
              means our subsidiaries, our ultimate holding company and its subsidiaries;
            </span>
          </li>
        </ol>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_17-1" start={3}>
          <li className="c39 li-bullet-0">
            <span className="c20">&nbsp;</span>
            <span className="c1">
              our third-party consultants, (sub-)contractors, suppliers or other service providers who may access your
              personal information to provide services (including but not limited to IT support services) to us in order to
              enable us to perform any contract we enter into with you;
            </span>
          </li>
        </ol>
        <p className="c70 c55 c75">
          <span className="c11"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) auditors or contractors or other advisers auditing, assisting with or advising on any of our business
            purposes;
          </span>
        </p>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) analytics and search engine providers that assist us in the improvement and optimization of our Website and
            the Services;
          </span>
        </p>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c19">
          <span className="c1">(i) our successors in title, our prospective sellers or buyers of our business;</span>
        </p>
        <p className="c76 c75 c55">
          <span className="c18"></span>
        </p>
        <p className="c67 c75">
          <span className="c1">
            (i) government bodies and law enforcement agencies and in response to other legal and regulatory requests;
          </span>
        </p>
        <p className="c27">
          <span className="c11"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) any third party where such disclosure is required in order to enforce or apply any contract, we enter into
            with you;
          </span>
        </p>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) any third party for the purposes of protecting the rights, property, or safety of our company, our customers,
            or others (including, without limitation, you). This includes exchanging information with other companies and
            organisations for the purposes of verifying your personal identification or address, fraud protection, anti-money
            laundering measures and credit risk reduction;
          </span>
        </p>
        <p className="c4">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0" start={9}>
          <li className="c17 li-bullet-0">
            <span className="c1">
              The User&rsquo;s Information may be transferred to, and stored at, a destination outside the European Economic
              Area (&quot;
            </span>
            <span className="c21 c2">EEA</span>
            <span className="c1">
              &quot;). It may also be processed by staff operating outside the EEA who work for us or for one of our service
              providers. Such staff may be engaged in, among other things, the processing of your payment details and the
              provision of support services. By submitting your User&rsquo;s Information, you agree to this transfer, storing
              or processing. We will take all steps reasonably necessary to ensure that the User&rsquo;s Information is
              treated securely and in accordance with this clause. All information you provide to us is stored on our secure
              servers. Any payment transactions will be encrypted using SSL technology.
            </span>
          </li>
        </ol>
        <p className="c37">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_1-0" start={10}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              The Act gives you the right to access information held about you. Your right of access can be exercised in
              accordance with the Act. Any access request may be subject to a reasonable fee to meet our costs in providing
              you with details of the information we hold about you.
            </span>
          </li>
        </ol>
        <p className="c6">
          <span className="c1"></span>
        </p>
        <hr style={{ pageBreakBefore: 'always', display: 'none' }} />
        <p className="c70 c69 c56 c55">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={12}>
          <li className="c12 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">Suspension of the Services</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_10-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              In addition to Dlocal&rsquo;s right to suspend the Services in accordance with the aforementioned clause,
              Dlocal reserves the right to, at any time, suspend the Services for repairs, maintenance or improvements. In
              the event that Dlocal suspends the Services in accordance with this clause, Dlocal will use its reasonable
              endeavors to give prior notice to the users, unless the Services are suspended due to suspicion of security
              breach or fraud.
            </span>
          </li>
        </ol>
        <p className="c6">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_10-0" start={2}>
          <li className="c79 c92 li-bullet-1">
            <span className="c1">
              Where the Services provided to you are suspended due to suspicion of security breach caused or fraud committed
              by you, Dlocal reserves the right to:
            </span>
          </li>
        </ol>
        <p className="c55 c89">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_10-1 start" start={1}>
          <li className="c78 li-bullet-2">
            <span className="c1">request that you provide information; and</span>
          </li>
        </ol>
        <p className="c13">
          <span className="c21 c38"></span>
        </p>
        <p className="c75 c95">
          <span className="c1">
            (i)&nbsp;&nbsp;at its sole discretion, restrict your access, suspend or terminate your Account without provision
            of any notice.
          </span>
        </p>
        <p className="c6 c87">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={13}>
          <li className="c12 li-bullet-0">
            <span className="c28">&nbsp; </span>
            <span className="c14">Term and termination</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_7-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              This Agreement shall commence on the date hereof and continue for an initial period of 24 (twenty-four) months
              (the &ldquo;Initial Term&rdquo;) with automatic 24 (twenty-four) months periods of renewal thereafter (the
              &ldquo;Renewal Terms&rdquo;), unless otherwise terminated pursuant to the terms hereof.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_7-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              In addition to any rights of termination provided hereunder: (i) any Party may terminate this Agreement at any
              time without cause upon 60 (sixty) calendar days prior written notice; and (ii) either Party may terminate this
              Agreement immediately should the other Party remain in breach of a material provision of this Agreement for
              more than ten (10) Business Days following notice thereof unless during the notice period the breach is cured
              to the Parties&rsquo; mutual satisfaction
            </span>
          </li>
        </ol>
        <p className="c66 c55">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_7-0" start={3}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              Where the Processor believes Merchant is acting illegally or not in compliance with the requirements set-out in
              this Agreement, the Processor shall, at its sole discretion, be entitled to terminate this Agreement
              immediately, or suspend or Disconnect the Payment Processing Services to the Merchant (and its Customers) until
              such time as the Merchant satisfies the Processor, that it is in compliance with its obligations.
            </span>
          </li>
        </ol>
        <p className="c55 c66">
          <span className="c58">
            <br />
          </span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={14}>
          <li className="c35 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">Our right to vary these terms</span>
          </li>
        </ol>
        <p className="c45 c68 c55">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_3-0 start" start={1}>
          <li className="c17 li-bullet-0">
            <span className="c1">
              We may revise these Terms from time to time. Every time you use our Services, the Terms in force at that time
              will apply to the provision of the Services to you.
            </span>
          </li>
        </ol>
        <p className="c37">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_3-0" start={2}>
          <li className="c31 li-bullet-0">
            <span className="c1">
              We reserve the right to make changes to the Website and the Services from time to time without any prior notice
              to you provided that such changes have no material adverse effect on you.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c20">
            <br />
          </span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={15}>
          <li className="c12 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">Liability and Indemnification</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_4-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c21 c2">Limitations of Liability</span>
            <span className="c1">
              . In no event shall we, our parent, subsidiaries and affiliates, our officers, directors, agents, employees or
              suppliers be liable for lost profits or any special, incidental or consequential damages (including without
              limitation damages for loss of data or loss of business) arising out of or in connection with our website,
              Dlocal Direct services, or this agreement (however arising, including negligence) unless and to the extent
              prohibited by law our liability, and the liability of our parent, subsidiaries and affiliates, our officers,
              directors, agents, joint ventures, employees and suppliers, to you or any third parties in any circumstance is
              limited to the actual amount of direct damages.
            </span>
          </li>
        </ol>
        <p className="c45 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_4-0" start={2}>
          <li className="c16 li-bullet-0">
            <span className="c1">We do not in any way exclude or limit our liability for:</span>
          </li>
        </ol>
        <ol className="c8 lst-kix_list_4-1 start" start={1}>
          <li className="c77 li-bullet-0">
            <span className="c1">death or personal injury caused by our negligence;</span>
          </li>
        </ol>
        <p className="c10">
          <span className="c21 c38"></span>
        </p>
        <p className="c19">
          <span className="c1">
            (i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fraud or fraudulent misrepresentation; and
          </span>
        </p>
        <p className="c13">
          <span className="c21 c38"></span>
        </p>
        <p className="c19">
          <span className="c1">
            (i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;any other liability which cannot be excluded or limited by
            applicable law.
          </span>
        </p>
        <p className="c7">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_4-0" start={3}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              You agree to indemnify and hold us harmless from any liabilities, claims, losses or demands made by any third
              party arising from your misuse of Dlocal Direct Services, which includes but is not limited to your breach of
              these Terms or a breach by you of any applicable law or rights of any third party. You also agree to fully
              cooperate in the defense of any claim that we may have to respond as a result of your misuse of the Services.
            </span>
          </li>
        </ol>
        <p className="c66 c55">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_4-0" start={4}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              We will make reasonable efforts to ensure that all transactions are processed in a timely manner. However, a
              number of factors may delay some transactions, many of which are beyond Dlocal&rsquo;s control, including
              without limitation, the processing time, communication failures and delays in the banking system. Dlocal shall
              not be liable for any loss or damages arising from delay in processing transactions.
            </span>
          </li>
        </ol>
        <p className="c4">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_4-0" start={5}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              We shall have no liability for defects on any goods or services sold to End Users and we shall not be liable
              for any charges, fees or other taxes in respect of such goods or services.
            </span>
          </li>
        </ol>
        <p className="c68 c83">
          <span className="c20">
            &nbsp; <br />
          </span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={16}>
          <li className="c12 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">Events outside our control</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_5-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              We will not be liable or responsible for any failure to perform, or delay in performance of, any of our
              obligations under these Terms that is caused by any act or event beyond our reasonable control, including
              without limitation strikes, lock- outs or other industrial action by third parties, civil commotion, riot,
              invasion, terrorist attack or threat of terrorist attack, war (whether declared or not) or threat or
              preparation for war, fire, explosion, storm, flood, earthquake, subsidence, epidemic or other natural disaster,
              or failure of public or private telecommunications networks.
            </span>
          </li>
        </ol>
        <p className="c36">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_5-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              In case such event takes place that affects the performance of our obligations under these Terms:
            </span>
          </li>
        </ol>
        <p className="c10">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_5-1 start" start={1}>
          <li className="c81 c82 li-bullet-0">
            <span className="c1">we will contact you as soon as reasonably possible to inform you; and</span>
          </li>
        </ol>
        <p className="c13">
          <span className="c21 c38"></span>
        </p>
        <p className="c24">
          <span className="c1">
            (i) our obligations under these Terms will be suspended and the time for performance of our obligations will be
            extended for the duration of such event.
            <br />
          </span>
        </p>
        <p className="c45 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={17}>
          <li className="c35 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">Communications between us</span>
          </li>
        </ol>
        <p className="c36">
          <span className="c21 c42"></span>
        </p>
        <ol className="c8 lst-kix_list_2-0 start" start={1}>
          <li className="c16 li-bullet-0">
            <span className="c1">When we refer, in these Terms, to &quot;in writing&quot;, this will include e-mail.</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c21 c38"></span>
        </p>
        <ol className="c8 lst-kix_list_2-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              If you wish to contact us in writing for any reason, you can send us a pre-paid post to Dlocal LLP, 4
              King&acute;s Bench Walk, London EC4Y 7DL, England, UK or email us &nbsp;at{' '}
            </span>
            <span className="c1">
              <a className="c80" href="mailto:legal@dlocal.com">
                legal@dlocal.com
              </a>
            </span>
          </li>
          <li className="c53 li-bullet-0">
            <span className="c1">
              If we have to contact you or give you notice in writing, we will do so by e-mail, phone or by pre-paid post to
              the address, phone number or email you provide to us as in your account details.
            </span>
          </li>
        </ol>
        <p className="c45 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_2-0" start={4}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              The provisions of this clause shall not apply to the service of any proceedings or other documents in any legal
              action.
              <br />
            </span>
          </li>
        </ol>
        <p className="c36">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={18}>
          <li className="c12 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">Governing law and jurisdiction</span>
          </li>
        </ol>
        <p className="c7">
          <span className="c14"></span>
        </p>
        <ol className="c8 lst-kix_list_13-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c1">These Terms are governed by and construed in accordance with the laws of </span>
            <span className="c20">United Kingdom</span>
            <span className="c1">.</span>
          </li>
        </ol>
        <p className="c37">
          <span className="c11"></span>
        </p>
        <ol className="c8 lst-kix_list_13-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">You and we both agree that the courts of </span>
            <span className="c20">London</span>
            <span className="c1">
              &nbsp;have exclusive jurisdiction to settle any dispute or claim that arises out of or in connection with these
              Terms (including non-contractual disputes or claims).
              <br />
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_15-0" start={19}>
          <li className="c12 li-bullet-0">
            <span className="c28">&nbsp;</span>
            <span className="c14">Other important Terms</span>
          </li>
        </ol>
        <p className="c36">
          <span className="c21 c42"></span>
        </p>
        <ol className="c8 lst-kix_list_9-0 start" start={1}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              These Terms together with the documents referred to in it, contains the entire agreement between us for your
              use of the Services.
            </span>
          </li>
        </ol>
        <p className="c45 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_9-0" start={2}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              If any part of these Terms is held unenforceable, that part shall be enforced to the maximum extent permitted
              by law so as to give effect to the intent of the parties, and the remaining part of these Terms shall continue
              in full force and effect.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_9-0" start={3}>
          <li className="c31 li-bullet-0">
            <span className="c1">
              These terms are between you and us. No other person shall have any rights to enforce any of its terms, whether
              under the Contracts (Rights of Third Parties Act) 1999 or otherwise.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_9-0" start={4}>
          <li className="c22 li-bullet-0">
            <span className="c1">
              We may transfer our rights and obligations under these Terms to another organisation without notice to you, but
              this will not affect your rights or our obligations under these Terms.
            </span>
          </li>
        </ol>
        <p className="c45 c68 c55">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_9-0" start={5}>
          <li className="c17 li-bullet-0">
            <span className="c1">
              If we fail to insist that you perform any of your obligations under these Terms, or if we do not enforce our
              rights against you, or if we delay in doing so, that will not mean that we have waived our rights against you
              and will not mean that you do not have to comply with those obligations. If we do waive a default by you, we
              will only do so in writing, and that will not mean that we will automatically waive any later default by you.
            </span>
          </li>
        </ol>
        <p className="c68 c55 c81">
          <span className="c1"></span>
        </p>
        <ol className="c8 lst-kix_list_9-0" start={6}>
          <li className="c17 li-bullet-0">
            <span className="c20 c52">
              In the event the Merchant has signed a Payment Processing Services Agreement and these Terms and Conditions,
              the Payment Processing Services Agreement shall prevai
            </span>
            <span className="c20">l.</span>
          </li>
        </ol>
        <div>
          <p className="c45 c55">
            <span className="c21 c62"></span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondotions;
